import React, {ReactNode} from 'react';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
interface Props {
    radioId: string
    radioName: string
    radioValue: string
    radionTitle: string
    additionalName?: string
    selectedValue: string
    onClick: (action: string) => void
}

export default class PokerPanelRadioButton extends React.Component<Props> {
    onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.props.onClick(this.props.selectedValue === e.target.value ? null : e.target.value);
    };

    render(): ReactNode {
        const {radioId, radioName, radioValue, radionTitle, additionalName, selectedValue} = this.props;

        return <label className={`poker-radio-button ${additionalName}`} htmlFor={radioId}>
            <input
                id={radioId}
                type="checkbox"
                name={radioName}
                value={radioValue}
                checked={selectedValue === radioValue}
                onChange={this.onChange}
            />
            <span className="icon-radio">
                <SpriteIcon name="#svg-check"/>
            </span>
            <span className="title-radio">{radionTitle}</span>
        </label>;
    }
}
